<app-dialog type="confirmation" [size]="DialogSize.SMALL" [dataSelector]="dataSelector + '-container'">
  <app-dialog-header [showClose]="false" [dataSelector]="dataSelector + '-header'">
    {{ title }}
  </app-dialog-header>

  <p class="px-6 ta--center body-300" [dataSelector]="dataSelector + '-primary-message'">
    {{ primaryMessage }}
  </p>

  <p class="mt-4 px-6 ta--center body-300" [dataSelector]="dataSelector + '-secondary-message'">
    {{ secondaryMessage }}
  </p>

  <app-dialog-footer [showCancel]="showCancel" [equalWidthButtons]="showCancel" [dataSelector]="dataSelector + '-footer'">
    <button
      andButton
      [color]="buttonColor"
      size="large"
      [mat-dialog-close]="true"
      [ngClass]="{ 'mx-auto w-50': !showCancel }"
      [dataSelector]="dataSelector + '-action-button'"
    >
      {{ buttonText }}
    </button>
  </app-dialog-footer>
</app-dialog>
